import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, interval: { type: Number, default: 2000 }, messages: Array }
  static targets = ["message"]

  MESSAGES = [
    "Reading recipe text...",
    "Deciphering handwriting...",
    "Extracting ingredients...",
    "Building directions...",
    "Almost there...",
    "Still working — hang tight..."
  ]

  connect() {
    this.messageIndex = 0
    this.poll()
    this.pollTimer = setInterval(() => this.poll(), this.intervalValue)
    this.messageTimer = setInterval(() => this.nextMessage(), 5000)
  }

  disconnect() {
    clearInterval(this.pollTimer)
    clearInterval(this.messageTimer)
  }

  async poll() {
    try {
      const response = await fetch(this.urlValue, {
        headers: { Accept: "application/json" }
      })

      if (!response.ok) return

      const data = await response.json()

      if (data.status === "complete" || data.status === "failed") {
        this.stop()
        window.location.href = this.urlValue.replace(".json", "")
      }
    } catch {
      // Network error — keep polling
    }
  }

  nextMessage() {
    const messages = this.messagesValue.length ? this.messagesValue : this.MESSAGES
    if (this.messageIndex < messages.length - 1) {
      this.messageIndex++
      if (this.hasMessageTarget) {
        this.messageTarget.textContent = messages[this.messageIndex]
      }
    }
  }

  stop() {
    clearInterval(this.pollTimer)
    clearInterval(this.messageTimer)
  }
}
